import {
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowRight,
  Award,
  BarChart2,
  Battery,
  Book,
  Briefcase,
  Cloud,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  Clock,
  Code,
  Copy,
  CornerUpLeft,
  CreditCard,
  Download,
  Edit2,
  ExternalLink,
  Eye,
  EyeOff,
  FileText,
  FolderPlus,
  Home,
  Image,
  Inbox,
  Info,
  Link,
  Loader,
  Lock,
  LogOut,
  Mail,
  Menu,
  Monitor,
  MoreVertical,
  Package,
  Paperclip,
  Phone,
  Play,
  Plus,
  Send,
  Share2,
  Shield,
  ShoppingCart,
  Tag,
  Trash2,
  Upload,
  User,
  UserPlus,
  Users,
  Video,
  X,
  XCircle,
} from 'angular-feather/icons';

export const icons = {
  ArrowRight,
  Award,
  Menu,
  X,
  ChevronUp,
  ChevronDown,
  ChevronRight,
  Loader,
  User,
  LogOut,
  Users,
  Briefcase,
  CreditCard,
  Battery,
  BarChart2,
  Cloud,
  Home,
  Book,
  MoreVertical,
  AlertCircle,
  Trash2,
  Tag,
  Plus,
  CheckCircle,
  CheckSquare,
  Code,
  Share2,
  Paperclip,
  ExternalLink,
  FileText,
  Image,
  Video,
  Copy,
  Download,
  Archive,
  CornerUpLeft,
  Shield,
  Info,
  Upload,
  AlertTriangle,
  XCircle,
  Eye,
  Check,
  Clock,
  Mail,
  Link,
  Lock,
  UserPlus,
  Monitor,
  Phone,
  ShoppingCart,
  Package,
  Inbox,
  Send,
  EyeOff,
  Edit2,
  Play,
  FolderPlus,
};
